import {animated, easings, useSpring} from 'react-spring';

// Auto-close countdown
const AiAssistantWidgetProgress = ({durationMs, onComplete}) => {
    const style = useSpring({
        from: {width: '0%'},
        to: {width: '100%'},
        config: {duration: durationMs, easing: easings.linear},
        onRest: () => onComplete(),
    });

    return (
        <div className='mx-auto h-[5px] w-[81px] overflow-hidden rounded-full bg-[#FFFDFB]'>
            <animated.div className='h-full rounded-full bg-color-tertiary' style={style} />
        </div>
    );
};

export default AiAssistantWidgetProgress;
